<section class="animated fadeIn bgWhite">
    <div class="gradBg"></div>
    <div class="container pRelativ">
      <div class="row headerBredcrm justify-content-between align-items-center mt-18 mb-10">
        <div class="leftSide">
          <p class="bredcrm">Dashboard</p>
        </div>
        <div class="rightSide glb-btn"> 
            <button class="btn secondry-button" routerLink="/quick-deligation">Create New Request</button> 
        </div>
      </div>
    </div>
    <div class="container pRelativ">
      <div class="row tabTable">
        <tabset>
          <tab class="requestTab">
            <ng-template tabHeading> My Approvals (05) </ng-template>
            <div class="slider">
              <carousel class="slide-animated" [itemsPerSlide]="itemsPerSlide" [singleSlideOffset]="singleSlideOffset" [noWrap]="!noWrap" [interval]="false" [startFromIndex]="0" [isAnimated]="true">
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-aam"></i></div>
                    <div class="cell">
                      <h4>Application Access Management</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-lms-2"></i></div>
                    <div class="cell">
                      <h4>Leave Management System</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-iTime1"></i></div>
                    <div class="cell">
                      <h4>iTime-Update Timesheet</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-lms-2"></i></div>
                    <div class="cell">
                      <h4>Leave Management System</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-iTime1"></i></div>
                    <div class="cell">
                      <h4>iTime-Update Timesheet</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-aam"></i></div>
                    <div class="cell">
                      <h4>Application Access Management</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-lms-2"></i></div>
                    <div class="cell">
                      <h4>Leave Management System</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-aam"></i></div>
                    <div class="cell">
                      <h4>Application Access Management</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
            <div class="d-flex justify-content-between mt-36 mb-8 align-items-center">
              <div class="leftSide">
                <h4 class="f-18 robertS">My Pending Approvals </h4> </div>
              <div class="rightSide">
                <div class="rightIcon">
                  <ul class="d-flex align-items-center mb-0">
                    <li>
                      <button (click)="viewll()"><span *ngIf="viewLess === false">View All</span> <span *ngIf="viewLess == true">View Less</span></button>
                    </li>
                    <li class="searchProject FormField2 lineIffect">
                      <div class="posRel empSearch">
                        <p-autoComplete [(ngModel)]="brand" [suggestions]="filteredBrands" (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search By Name or User ID" panelStyleClass="panelClass"></p-autoComplete>
                        <i class="icon-search"></i>
                    </div>
                    </li>
                    <li tooltip="Filter" placement="top" container="body" class="mr-0"><i (click)="visibleSidebar2 = true" class="icon-filter"></i></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="customTable">
              <div class="tableHeader">
                <div class="table-row">
                  <div class="tabel-div w-25">
                    <div class="table-cell w-40">
                      <label class="checkbox-label">
                        <input type="checkbox" class="check1" [(ngModel)]="mast" (change)="master()"> <span class="checkbox-custom"></span> <span class="checkText tableHd">Request ID</span> </label>
                    </div>
                    <div class="table-cell w-50">Application/Role</div>
                  </div>
                  <div class="tabel-div w-40">
                    <div class="table-cell w-30">Delegator/SAP ID</div>
                    <div class="table-cell w-30">Delegatee /SAP ID</div>
                    <div class="table-cell w-33">Duration/Days</div>
                  </div>
                  <div class="tabel-div w-28">
                    <div class="table-cell w-22">Remarks</div>
                    <div class="table-cell w-37">Mailer Restricted</div>
                    <div class="table-cell w-40">Download</div>
                  </div>
                  <div class="tabel-div w-7 justify-content-center">
                    <div class="table-cell w-100 text-center">Action</div>
                  </div>
                </div>
              </div>
              <div class="tableBody">
                <div class="table-row">
                  <div class="tabel-div w-25">
                    <div class="table-cell w-40">
                      <label class="checkbox-label">
                        <input type="checkbox" class="check1" [(ngModel)]="child1" (change)="child()"> <span class="checkbox-custom"></span> <span class="checkText tableHd">50303887</span> </label>
                    </div>
                    <div class="table-cell w-50">
                      <div class="upText">Exit Management</div>
                      <div class="boText">Central HR | <span><a class="sbuText" triggers="mouseenter:mouseleave"  placement="bottom" container="body" (click)="shareTemplate.toggle($event)" href="javaScript:void(0)">SBU </a><i  class="hdr-shear-link"></i></span> </div>
                    </div>
                  </div>
                  <div class="tabel-div w-40">
                    <div class="table-cell w-30">
                      <div class="upText">Niharika Tripathi</div>
                      <div class="boText">(51864408)</div>
                    </div>
                    <div class="table-cell w-30">
                      <div class="upText">Pawan Gupta</div>
                      <div class="boText">(40126567)</div>
                    </div>
                    <div class="table-cell w-33">
                      <div class="upText">03-Mar-23 to 04-May-24</div>
                      <div class="boText">(90 Days)</div>
                    </div>
                  </div>
                  <div class="tabel-div w-28">
                    <div class="table-cell w-22">
                      <div class="boText"><span><a class="remarkIcon" triggers="mouseenter:mouseleave" placement="bottom" container="body" (click)="chatTemplate.toggle($event)" href="javaScript:void(0)"><i  class="hdr-chat"></i></a></span> </div>
                    </div>
                    <div class="table-cell w-37">
                      <div class="bages approve">Yes</div>
                    </div>
                    <div class="table-cell w-47">
                      <a href="../../../assets/images/sample-PDF.pdf" download="" class="attachmentLink"> <span class="hdr-attachment-normal f-16"></span> Attachme… .png</a>
                    </div>
                  </div>
                  <div class="tabel-div w-7">
                    <div class="table-cell W-100 actionWarp">
                      <a href="javaScript:void(0)" class="" (click)="openModal(approvedModal)"> <span tooltip="Approve" container="body" placement="top" class="hdr-checklist"></span></a>
                      <a href="javaScript:void(0)" class="" (click)="rejectModal.show()"> <span tooltip="Reject" container="body" placement="top" class="hdr-referback"></span></a>
                    </div>
                  </div>
                </div>
                <div class="table-row">
                  <div class="tabel-div w-25">
                    <div class="table-cell w-40">
                      <label class="checkbox-label">
                        <input type="checkbox" class="check1" [(ngModel)]="child2" (change)="child()"> <span class="checkbox-custom"></span> <span class="checkText tableHd">50303887</span> </label>
                    </div>
                    <div class="table-cell w-50">
                      <div class="upText">Billing Request</div>
                      <div class="boText">Central HR | SBU</div>
                    </div>
                  </div>
                  <div class="tabel-div w-40">
                    <div class="table-cell w-30">
                      <div class="upText">Niharika Tripathi</div>
                      <div class="boText">(51864408)</div>
                    </div>
                    <div class="table-cell w-30">
                      <div class="upText">Pawan Gupta</div>
                      <div class="boText">(40126567)</div>
                    </div>
                    <div class="table-cell w-33">
                      <div class="upText">03-Mar-23 to 04-May-24</div>
                      <div class="boText">(90 Days)</div>
                    </div>
                  </div>
                  <div class="tabel-div w-28">
                    <div class="table-cell w-22">
                      <div class="boText"><span><a class="remarkIcon" triggers="mouseenter:mouseleave" placement="bottom" container="body" (click)="chatTemplate.toggle($event)" href="javaScript:void(0)"><i  class="hdr-chat"></i></a></span> </div>
                    </div>
                    <div class="table-cell w-37">
                      <div class="bages reject">No</div>
                    </div>
                    <div class="table-cell w-47"> </div>
                  </div>
                  <div class="tabel-div w-7">
                    <div class="table-cell W-100 actionWarp">
                      <a href="javaScript:void(0)" class="" (click)="openModal(approvedModal)"> <span tooltip="Approve" container="body" placement="top" class="hdr-checklist"></span></a>
                      <a href="javaScript:void(0)" class="" (click)="rejectModal.show()"> <span tooltip="Reject" container="body" placement="top" class="hdr-referback"></span></a>
                    </div>
                  </div>
                </div>
                <div class="table-row">
                  <div class="tabel-div w-25">
                    <div class="table-cell w-40">
                      <label class="checkbox-label">
                        <input type="checkbox" class="check1" [(ngModel)]="child3" (change)="child()"> <span class="checkbox-custom"></span> <span class="checkText tableHd">50303887</span> </label>
                    </div>
                    <div class="table-cell w-50">
                      <div class="upText">Leave Management</div>
                      <div class="boText">Central HR | SBU</div>
                    </div>
                  </div>
                  <div class="tabel-div w-40">
                    <div class="table-cell w-30">
                      <div class="upText">Niharika Tripathi</div>
                      <div class="boText">(51864408)</div>
                    </div>
                    <div class="table-cell w-30">
                      <div class="upText">Pawan Gupta</div>
                      <div class="boText">(40126567)</div>
                    </div>
                    <div class="table-cell w-33">
                      <div class="upText">03-Mar-23 to 04-May-24</div>
                      <div class="boText">(90 Days)</div>
                    </div>
                  </div>
                  <div class="tabel-div w-28">
                    <div class="table-cell w-22">
                      <div class="boText"><span><a class="remarkIcon" triggers="mouseenter:mouseleave" placement="bottom" container="body" (click)="chatTemplate.toggle($event)" href="javaScript:void(0)"><i  class="hdr-chat"></i></a></span> </div>
                    </div>
                    <div class="table-cell w-37">
                      <div class="bages approve">Yes</div>
                    </div>
                    <div class="table-cell w-47">
                      <a href="../../../assets/images/sample-PDF.pdf" download="" class="attachmentLink"> <span class="hdr-attachment-normal f-16"></span> Attachme… .png</a>
                    </div>
                  </div>
                  <div class="tabel-div w-7">
                    <div class="table-cell W-100 actionWarp">
                      <a href="javaScript:void(0)" class="" (click)="openModal(approvedModal)"> <span tooltip="Approve" container="body" placement="top" class="hdr-checklist"></span></a>
                      <a href="javaScript:void(0)" class="" (click)="rejectModal.show()"> <span tooltip="Reject" container="body" placement="top" class="hdr-referback"></span></a>
                    </div>
                  </div>
                </div>
                <div class="table-row">
                  <div class="tabel-div w-25">
                    <div class="table-cell w-40">
                      <label class="checkbox-label">
                        <input type="checkbox" class="check1" [(ngModel)]="child4" (change)="child()"> <span class="checkbox-custom"></span> <span class="checkText tableHd">50303887</span> </label>
                    </div>
                    <div class="table-cell w-50">
                      <div class="upText">Resource Assignation</div>
                      <div class="boText">Central HR | SBU</div>
                    </div>
                  </div>
                  <div class="tabel-div w-40">
                    <div class="table-cell w-30">
                      <div class="upText">Niharika Tripathi</div>
                      <div class="boText">(51864408)</div>
                    </div>
                    <div class="table-cell w-30">
                      <div class="upText">Pawan Gupta</div>
                      <div class="boText">(40126567)</div>
                    </div>
                    <div class="table-cell w-33">
                      <div class="upText">03-Mar-23 to 04-May-24</div>
                      <div class="boText">(90 Days)</div>
                    </div>
                  </div>
                  <div class="tabel-div w-28">
                    <div class="table-cell w-22">
                      <div class="boText"><span><a class="remarkIcon" triggers="mouseenter:mouseleave" placement="bottom" container="body" (click)="chatTemplate.toggle($event)" href="javaScript:void(0)"><i  class="hdr-chat"></i></a></span> </div>
                    </div>
                    <div class="table-cell w-37">
                      <div class="bages reject">No</div>
                    </div>
                    <div class="table-cell w-47">
                      <a href="../../../assets/images/sample-PDF.pdf" download="" class="attachmentLink"> <span class="hdr-attachment-normal f-16"></span> Attachme… .png</a>
                    </div>
                  </div>
                  <div class="tabel-div w-7">
                    <div class="table-cell W-100 actionWarp">
                      <a href="javaScript:void(0)" class="" (click)="openModal(approvedModal)"> <span tooltip="Approve" container="body" placement="top" class="hdr-checklist"></span></a>
                      <a href="javaScript:void(0)" class="" (click)="rejectModal.show()"> <span tooltip="Reject" container="body" placement="top" class="hdr-referback"></span></a>
                    </div>
                  </div>
                </div>
                <div class="table-row" *ngIf="viewAll">
                  <div class="tabel-div w-25">
                    <div class="table-cell w-40">
                      <label class="checkbox-label">
                        <input type="checkbox" class="check1" [(ngModel)]="child5" (change)="child()"> <span class="checkbox-custom"></span> <span class="checkText tableHd">50303887</span> </label>
                    </div>
                    <div class="table-cell w-50">
                      <div class="upText">Visa Ready Travel Ready</div>
                      <div class="boText">Central HR | SBU</div>
                    </div>
                  </div>
                  <div class="tabel-div w-40">
                    <div class="table-cell w-30">
                      <div class="upText">Niharika Tripathi</div>
                      <div class="boText">(51864408)</div>
                    </div>
                    <div class="table-cell w-30">
                      <div class="upText">Pawan Gupta</div>
                      <div class="boText">(40126567)</div>
                    </div>
                    <div class="table-cell w-33">
                      <div class="upText">03-Mar-23 to 04-May-24</div>
                      <div class="boText">(90 Days)</div>
                    </div>
                  </div>
                  <div class="tabel-div w-28">
                    <div class="table-cell w-22">
                      <div class="boText"><span><a class="remarkIcon" triggers="mouseenter:mouseleave" placement="bottom" container="body" (click)="chatTemplate.toggle($event)" href="javaScript:void(0)"><i  class="hdr-chat"></i></a></span> </div>
                    </div>
                    <div class="table-cell w-37">
                      <div class="bages approve">Yes</div>
                    </div>
                    <div class="table-cell w-47"> </div>
                  </div>
                  <div class="tabel-div w-7">
                    <div class="table-cell W-100 actionWarp">
                      <a href="javaScript:void(0)" class="" (click)="openModal(approvedModal)"> <span tooltip="Approve" container="body" placement="top" class="hdr-checklist"></span></a>
                      <a href="javaScript:void(0)" class="" (click)="rejectModal.show()"> <span tooltip="Reject" container="body" placement="top" class="hdr-referback"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ctaBtnWarp d-flex justify-content-center mt-24 glb-btn">
                <button (click)="rejectModal.show()" type="button" class="btn secondry-button">Reject</button>
                <button (click)="openModal(approvedModal)" type="button" class="btn primary-button">Approve</button>
              </div>
          </tab>
          <tab class="initiateTab">
            <ng-template tabHeading> My Request ({{totalRequestRows}}) </ng-template>
            <div class="slider">
              <carousel [itemsPerSlide]="itemsPerSlide" [singleSlideOffset]="singleSlideOffset" [noWrap]="!noWrap" [interval]="false" [startFromIndex]="0">
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-aam"></i></div>
                    <div class="cell">
                      <h4>Application Access Management</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-lms-2"></i></div>
                    <div class="cell">
                      <h4>Leave Management System</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <!-- <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-iTime1"></i></div>
                    <div class="cell">
                      <h4>iTime-Update Timesheet</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-lms-2"></i></div>
                    <div class="cell">
                      <h4>Leave Management System</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-iTime1"></i></div>
                    <div class="cell">
                      <h4>iTime-Update Timesheet</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-aam"></i></div>
                    <div class="cell">
                      <h4>Application Access Management</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-lms-2"></i></div>
                    <div class="cell">
                      <h4>Leave Management System</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide>
                <slide class="animated fadeIn">
                  <div class="cardCars">
                    <div class="cell iconS"><i class="hdr-aam"></i></div>
                    <div class="cell">
                      <h4>Application Access Management</h4>
                      <p> <span class="sText action">PMO</span> <span class="sText action">LOB Head</span> </p>
                    </div>
                  </div>
                </slide> -->
              </carousel>
            </div>
            <div class="d-flex justify-content-between mt-36 mb-8 align-items-center">
              <div class="leftSide">
                <h4 class="f-18 robertS">My Requests</h4> </div>
              <div class="rightSide">
                <div class="rightIcon">
                  <ul class="d-flex align-items-center mb-0">
                    <li>
                      <button (click)="viewll()"><span *ngIf="viewLess === false">View All</span> <span *ngIf="viewLess == true">View Less</span></button>
                    </li>
                    <li class="searchProject FormField2 lineIffect">
                      <div class="posRel empSearch">
                        <p-autoComplete [(ngModel)]="brand" [suggestions]="filteredBrands" (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search By Name or User ID" panelStyleClass="panelClass"></p-autoComplete>
                        <i class="icon-search"></i>
                    </div>
                    </li>
                    <li tooltip="Filter" placement="top" container="body" class="mr-0"><i (click)="visibleSidebar2 = true" class="icon-filter"></i></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="customTable" *ngFor='let myRequests of topFiveMyRequestData;let i=index'>
              <div class="tableBody">
                <div class="table-row2">
                  <div class="tableCardHeader d-flex justify-content-between">
                    <h4>{{myRequests.ApplicationCode}}</h4>
                    <div class="bages pennding" *ngIf="(myRequests.RequestStatus ==='Pending RM Approval')">Pending</div>
                    <div class="bages reject" *ngIf="(myRequests.RequestStatus === 'Rejected')">Reject</div>
                    <div class="bages approve" *ngIf="(myRequests.RequestStatus === 'Approved')">Approved</div>
                    <div class="bages reject" *ngIf="(myRequests.RequestStatus === 'Cancelled')">Cancelled</div>
                  </div>
                  <div class="tableDivWarp">
                    <div class="tabel-div w-100">
                      <div class="table-cell w-12">
                        <label for="" class="customLabel">Request ID</label>
                        <p class="labelFor">{{myRequests.Del_ReqId}}</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Delegatee /SAP ID</label>
                        <p class="labelFor">{{myRequests.DelegateeName|titlecase}}
                          ({{myRequests.DelegateeSAPId}})</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Role</label>
                        <div class="boText">{{myRequests.RoleName}}  | <span><a class="sbuText" triggers="mouseenter:mouseleave"  placement="bottom" container="body" (click)="shareTemplate.toggle($event)" href="javaScript:void(0)">SBU </a><i  class="hdr-shear-link"></i></span> </div>
                      </div>
                      <div class="table-cell w-25">
                        <label for="" class="customLabel">Duration/Days</label>
                        <p class="labelFor">{{myRequests.DelegationStartDate}} to
                          {{myRequests.DelegationEndDatetime}} 
                          ({{calcluateDateDiff(myRequests.DelegationEndDatetime,myRequests.DelegationStartDate)}})</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Pending On</label>
                        <p class="labelFor">{{myRequests.ApproverName}} {{myRequests.ApproverSapId}}</p>
                      </div>
                      <div class="table-cell w-3 last-cell">
                        <button (click)="rejectModal2.show()" class="requestCancleBtn"><i tooltip="Cancel" class="hdr-cancel"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="table-row2">
                  <div class="tableCardHeader d-flex justify-content-between">
                    <h4>Visa Ready Travel Ready</h4>
                    <div class="bages reject">Reject</div>
                  </div>
                  <div class="tableDivWarp">
                    <div class="tabel-div w-100">
                      <div class="table-cell w-12">
                        <label for="" class="customLabel">Request ID</label>
                        <p class="labelFor">50303887</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Delegatee /SAP ID</label>
                        <p class="labelFor">Pawan Gupta (40126567)</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Role</label>
                        <div class="boText">Central HR | <span><a class="sbuText" triggers="mouseenter:mouseleave"  placement="bottom" container="body" (click)="shareTemplate.toggle($event)" href="javaScript:void(0)">SBU </a><i  class="hdr-shear-link"></i></span> </div>
                      </div>
                      <div class="table-cell w-25">
                        <label for="" class="customLabel">Duration/Days</label>
                        <p class="labelFor">03-Mar-23 to 04-May-23 (90 Days)</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Pending On</label>
                        <p class="labelFor">Niharika Tripathi (51864408)</p>
                      </div>
                      <div class="table-cell w-3 last-cell">
                        <button (click)="rejectModal2.show()" class="requestCancleBtn"><i tooltip="Cancel" class="hdr-cancel"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-row2">
                  <div class="tableCardHeader d-flex justify-content-between">
                    <h4>Travel Authorization</h4>
                    <div class="bages approve">Approved</div>
                  </div>
                  <div class="tableDivWarp">
                    <div class="tabel-div w-100">
                      <div class="table-cell w-12">
                        <label for="" class="customLabel">Request ID</label>
                        <p class="labelFor">50303887</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Delegatee /SAP ID</label>
                        <p class="labelFor">Pawan Gupta (40126567)</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Role</label>
                        <div class="boText">Central HR | <span><a class="sbuText" triggers="mouseenter:mouseleave"  placement="bottom" container="body" (click)="shareTemplate.toggle($event)" href="javaScript:void(0)">SBU </a><i  class="hdr-shear-link"></i></span> </div>
                      </div>
                      <div class="table-cell w-25">
                        <label for="" class="customLabel">Duration/Days</label>
                        <p class="labelFor">03-Mar-23 to 04-May-23 (90 Days)</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Pending On</label>
                        <p class="labelFor">Niharika Tripathi (51864408)</p>
                      </div>
                      <div class="table-cell w-3 last-cell">
                        <button (click)="rejectModal2.show()" class="requestCancleBtn"><i tooltip="Cancel" class="hdr-cancel"></i></button>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="table-row2" *ngIf="viewAll">
                  <div class="tableCardHeader d-flex justify-content-between">
                    <h4>Exit Management</h4>
                    <div class="bages pennding">Pending</div>
                  </div>
                  <div class="tableDivWarp">
                    <div class="tabel-div w-100">
                      <div class="table-cell w-12">
                        <label for="" class="customLabel">Request ID</label>
                        <p class="labelFor">50303887</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Delegatee /SAP ID</label>
                        <p class="labelFor">Pawan Gupta (40126567)</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Role</label>
                        <div class="boText">Central HR | <span><a class="sbuText" triggers="mouseenter:mouseleave"  placement="bottom" container="body" (click)="shareTemplate.toggle($event)" href="javaScript:void(0)">SBU </a><i  class="hdr-shear-link"></i></span> </div>
                      </div>
                      <div class="table-cell w-25">
                        <label for="" class="customLabel">Duration/Days</label>
                        <p class="labelFor">03-Mar-23 to 04-May-23 (90 Days)</p>
                      </div>
                      <div class="table-cell w-20">
                        <label for="" class="customLabel">Pending On</label>
                        <p class="labelFor">Niharika Tripathi (51864408)</p>
                      </div>
                      <div class="table-cell w-3 last-cell">
                        <button (click)="rejectModal2.show()" class="requestCancleBtn"><i tooltip="Cancel" class="hdr-cancel"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab>
        </tabset>
      </div>
    </div>
  </section>


<!-- share Roles -->
<p-overlayPanel #shareTemplate>
    <div class="roles">
        <h4>Sub-Roles</h4>
       <p class="popoverText">EIS - DU1 (54919450) | EIS - DU1 (549194502)</p>
    </div>
</p-overlayPanel> 

<!-- share Roles -->
<p-overlayPanel #chatTemplate>
    <div class="roles">
       <p class="popoverText mt-0">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.</p>
    </div>
</p-overlayPanel> 

<!-- Filter -->
<p-sidebar class="filter" [(visible)]="visibleSidebar2" position="right" [style]="{width:'340px'}">
    <div class="filter-body">
        <h3>Filter <button class="close" aria-label="close filter" (click)="visibleSidebar2 = false"><i class="icon-cancel"></i></button> </h3>
        <div class="FormField">
            <label>Request ID</label>
            <div class="posRel FormField2">
              <p-autoComplete [(ngModel)]="brand" [suggestions]="filteredBrands" (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search By Name or User ID" panelStyleClass="panelClass"></p-autoComplete>
              <i class="icon-search"></i>
            </div>
        </div>
        <div class="FormField">
            <label>Application</label>
            <p-dropdown [options]="option1"></p-dropdown>
        </div>
        <div class="FormField">
            <label>Role</label>
            <p-dropdown [options]="option1"></p-dropdown>
        </div>
        <div class="FormField mb-0">
            <label>Status</label>
            <p-dropdown [options]="option1"></p-dropdown>
        </div>
        <div class="text-center glb-btn mt-16">
            <button class="btn secondry-button">Reset</button>
            <button class="btn primary-button" (click)="visibleSidebar2 = false">Apply</button>
        </div>
    </div>
<!-- </div> -->
 </p-sidebar>


  <!-- Approve Modal Box Start  -->
  <ng-template #approvedModal>
      <div class="modal-body successModal">
          <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide(); hideSuccessMsg()">
              <span aria-hidden="true" class="visually-hidden">&times;</span>
            </button>
          <div class="mtable">
              <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" />  </span>
            <p class="">Request has been approved successfully.</p>
          </div>
      </div>
    </ng-template>

  <!-- Reject Modal Box Start  -->
 <div bsModal #rejectModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg">
    <div class="modal-content">
    <div class="modal-header">
        <h4 id="dialog-sizes-name1" class="modal-title pull-left">Rejection Remarks</h4>
        <button type="button" class="btn-close close pull-right" (click)="rejectModal.hide()" aria-label="Close">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-area text-center">
          <textarea class="form-control remarks" placeholder="Type here..." rows="4" cols="4"></textarea>
          <div class="mickWarp"><span class="hdr-mick"></span></div>
          <div class="glb-btn mt-40">
            <button  type="button" class="btn primary-button" (click)="rejectModal.hide(); openModal(approvedModal); addClassToBody()">Submit</button>
          </div>
        </div>
    </div>
    </div>
    </div>
</div> 

<!-- Reject Request Delete Modal Box Start  -->
<div bsModal #rejectModal2="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog">
  <div class="modal-content">
  <div class="modal-body d-flex justify-content-center">
      <div class="mCell text-center">
        <span class="alertIcon"> <i class="hdr-attention"></i> </span>
        <h3>Are you sure you want to delete request?</h3>
        <div class="glb-btn mt-40">
            <button (click)="rejectModal2.hide();" class="btn secondry-button">No</button>
          <button  type="button" class="btn primary-button" (click)="rejectModal2.hide(); openModal(deletRequestModal);">Yes</button>
        </div>
      </div>
  </div>
  </div>
  </div>
</div> 


  <!--  Reject Request Delete successfully  Modal Box Start  -->
  <ng-template #deletRequestModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" />  </span>
          <p class="">Request has been delete successfully.</p>
        </div>
    </div>
  </ng-template>